/**
 * className composition utility
 * Combines clsx with Tailwind merge for optimal className handling
 */

import { clsx, type ClassValue } from 'clsx'

/**
 * Compose multiple className values into a single string
 * Handles conditional classes, arrays, and objects
 *
 * @example
 * cn('text-base', isActive && 'font-bold', ['p-4', 'm-2'])
 * // Returns: "text-base font-bold p-4 m-2"
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs)
}
